import { IChangeResponsibleManagerModalProps } from "../../../interfaces/props/AdminManagerInfo/IChangeResponsibleManagerModalProps";
import { useGetPermissionQuery } from "../../../store/api/permission.api";
import { getFullName } from "../../utilities/getFullNameStringFromObject";

export const useGetReattachAvaiableManagerList = (
  currentManagerId?: number,
) => {
  const { data: permissionData } = useGetPermissionQuery(undefined);
  const permissionManagerList = permissionData?.data.manager || [];

  const managerList: IChangeResponsibleManagerModalProps["managerList"] =
    permissionManagerList
      .filter((el) => {
        return el.id !== currentManagerId && el.is_enabled && !el.is_banned;
      })
      .map((el) => {
        return {
          id: el.id,
          fullName: getFullName(el),
        };
      });

  return managerList;
};
